<ng-container *hasPermission="['REPORT_BUILDER_READ', 'REPORT_BUILDER_ALL']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Dettaglio report - <b>{{detail_title}}</b></h2>
        </div>
        <form name="organizationForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row">
                <div class="col-md-6 ">
                    <label for="name" class="form-label">Name</label>
                    <input type="text" class="form-control" id="name" name="name" ngModel #name="ngModel"
                        [(ngModel)]="reportTemplate.name" required />

                </div>
                <div class="col-md-6">
                    <label for="name" class="form-label">Tipologia</label>
                    <select class="form-select" aria-label="Tipo" id="type" name="type"
                        [(ngModel)]="reportTemplate.type" required>
                        <option selected value=""></option>
                        <option *ngFor="let reportTemplateType of reportTemplateTypes" [value]="reportTemplateType.id">
                            {{reportTemplateType.description}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label for="enabled" class="form-label">Attiva</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="enabled" role="switch" name="enabled"
                            ngModel #enabled="ngModel" [(ngModel)]="reportTemplate.enabled">
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-12 ">
                    <label for="enabled" class="form-label">Intestazione</label>
                </div>
                <div class="col-12 ">
                    <angular-editor #angularEditorHeader [placeholder]="'Inserici il tuo template...'"
                        [(ngModel)]="headerHTML" name="headerHTML" id="headerHTML" [config]="editorHeaderConfig">
                        <ng-template #customButtons let-executeCommandFn="executeCommandFn">
                            <ae-toolbar-set>
                                <ae-button iconClass="fa-solid fa-question" title="Variabili"
                                    (buttonClick)="showHideVarialePanel(true)"></ae-button>
                                <div class="var-div-container" [ngClass]="showHideVariableClassHeader">
                                    <div class="var-box">
                                        <div class="var-div">
                                            <div class="input-group mb-1">
                                                <div class="input-group-text">&#64;</div>
                                                <input type="text" class="form-control" placeholder="Cerca"
                                                    (keyup)="filterVars($event)">
                                            </div>

                                            @for (reportTemplateVariable of reportTemplateVariablesFiltered; track
                                            $index) {
                                            <div class="var-button">
                                                <ae-button iconClass="fa-solid fa-plus" title="Aggiungi"
                                                    (buttonClick)="showHideVarialePanel(true);executeCommandFn('insertHtml', reportTemplateVariable.id)">
                                                </ae-button>
                                            </div>
                                            <div class="var-name">
                                                {{reportTemplateVariable.name}}
                                            </div>

                                            <div class="var-separator"></div>
                                            }


                                        </div>
                                    </div>

                                </div>
                            </ae-toolbar-set>
                        </ng-template>
                    </angular-editor>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-12 ">
                    <label for="enabled" class="form-label">Verbalino</label>
                </div>
                <div class="col-12 ">
                    <angular-editor #angularEditor [placeholder]="'Inserisci il tuo...'" [(ngModel)]="innerHTML"
                        name="innerHTML" id="innerHTML" [config]="editorConfig">
                        <ng-template #customButtons let-executeCommandFn="executeCommandFn">
                            <ae-toolbar-set>
                                <ae-button iconClass="fa-solid fa-question" title="Variabili"
                                    (buttonClick)="showHideVarialePanel(false)"></ae-button>
                                <div class="var-div-container" [ngClass]="showHideVariableClass">
                                    <div class="var-box">
                                        <div class="var-div">
                                            <div class="input-group mb-1">
                                                <div class="input-group-text">&#64;</div>
                                                <input type="text" class="form-control" placeholder="Cerca"
                                                    (keyup)="filterVars($event)">
                                            </div>

                                            @for (reportTemplateVariable of reportTemplateVariablesFiltered; track
                                            $index) {
                                            <div class="var-button">
                                                <ae-button iconClass="fa-solid fa-plus" title="Aggiungi"
                                                    (buttonClick)="showHideVarialePanel(false);executeCommandFn('insertHtml', reportTemplateVariable.id)">
                                                </ae-button>
                                            </div>
                                            <div class="var-name">
                                                {{reportTemplateVariable.name}}
                                            </div>

                                            <div class="var-separator"></div>
                                            }


                                        </div>
                                    </div>

                                </div>
                            </ae-toolbar-set>
                        </ng-template>
                    </angular-editor>

                    <div class="d-flex justify-content-end  align-items-center mt-2 gap-2">
                        <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                            data-bs-target="#preview72">Preview 72mm
                        </button>
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                            data-bs-target="#previewA4">Preview A4
                        </button>


                        <ng-template [hasPermission]="['REPORT_BUILDER_DELETE', 'REPORT_BUILDER_ALL']">
                            @if (reportTemplate.id !== undefined) {
                            <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                                Elimina
                            </button>
                            }
                        </ng-template>
                        <ng-template [hasPermission]="['REPORT_BUILDER_UPDATE', 'REPORT_BUILDER_ALL']">
                            @if (reportTemplate.id !== undefined) {

                            <button type="submit" class="btn btn-primary">
                                Salva
                            </button>
                            }
                        </ng-template>
                        <ng-template [hasPermission]="['REPORT_BUILDER_CREATE', 'REPORT_BUILDER_ALL']">
                            @if (reportTemplate.id === undefined) {
                            <button type="submit" class="btn btn-primary">
                                Salva
                            </button>
                            }

                        </ng-template>

                      
                    </div>
                </div>
            </div>
        </form>
        <app-confirm-alert [confirmationMessage]="'Eliminazione template - '+confirmationMessage"
            [showConfirmationModal]="showConfirmationModal" (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
        </app-confirm-alert>
    </div>


    <!-- Modal -->
    <div class="modal fade" id="preview72" tabindex="-1" aria-labelledby="preview72Lbl" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="preview72Lbl">Preview 72mm</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="small-printer-viewer" [innerHTML]="previewHTML"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal modal-xl fade" id="previewA4" tabindex="-1" aria-labelledby="previewA4Lbl" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="previewA4Lbl">Preview A4</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="a4-printer-viewer" [innerHTML]="previewHTML"></div>
                </div>
            </div>
        </div>
    </div>


</ng-container>